<script setup lang="ts">
import { computed } from "vue";

interface ImageWidgetProps {
  base64Src: string;
  mediaType: string;
  alt?: string;
}

const { base64Src, mediaType, alt = "" } = defineProps<ImageWidgetProps>();

const src = computed(() => {
  // ensure that media type really contains base64
  const mt = mediaType.endsWith(";base64") ? mediaType : `${mediaType};base64`;
  const cleanedBase64 = base64Src.includes(",")
    ? base64Src.substring(base64Src.indexOf(",") + 1)
    : base64Src;
  return `data:${mt}, ${cleanedBase64}`;
});
</script>

<template>
  <img :src="src" :alt="alt" />
</template>
